<template>
  <div class="card-item">
    <div id="summary">
      <strong>Waiter</strong>
      <!-- <em>Table1</em> -->
      <small>Allocated to Table </small>
      <!-- <small>Available</small> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
};
</script>

